import { _ as _slicedToArray } from '../unsorted/slicedToArray.js';
import { _ as _asyncToGenerator, a as _regeneratorRuntime } from '../unsorted/index4.js';
import { useState } from 'react';
import { useBrowserLayoutEffect } from './useBrowserLayoutEffect.js';

function urlIsSvg(_x) {
  return _urlIsSvg.apply(this, arguments);
}
/**
 * This function detects whether an image URL is an SVG image or not.
 * @param {UseDetectSvgImagePropTypes}  - The function `useDetectSvgImage` takes in an object with a
 * single property `imageUrl`, which is a string representing the URL of an image. The function returns
 * a boolean value indicating whether the image at the given URL is an SVG image or not.
 * @returns The function `useDetectSvgImage` returns a boolean value indicating whether the provided
 * image URL is an SVG image or not.
 */
function _urlIsSvg() {
  _urlIsSvg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var imageResponse;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetch(url, {
            method: "HEAD"
          });
        case 3:
          imageResponse = _context.sent;
          return _context.abrupt("return", imageResponse.headers.get("content-type") === "image/svg+xml");
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](0);
          console.error("urlIsSvg() HEADERS Fetch Error:", url, _context.t0);
          return _context.abrupt("return", false);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 7]]);
  }));
  return _urlIsSvg.apply(this, arguments);
}
function useDetectSvgImage(_ref) {
  var imageUrl = _ref.imageUrl;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    imageIsSvg = _useState2[0],
    setImageIsSvg = _useState2[1];
  useBrowserLayoutEffect(function () {
    if (imageUrl) {
      urlIsSvg(imageUrl).then(function (isSvg) {
        setImageIsSvg(isSvg);
      });
    }
  }, [imageUrl]);
  return imageIsSvg;
}

export { useDetectSvgImage };
//# sourceMappingURL=useDetectSvgImage.js.map
